import cn from "classnames"

import { useIssue } from "@/api/useTriage"
import { Button, Flex, Skeleton } from "@/atoms"
import { useTranslation } from "@/hooks/useTranslation"
import { FunctionOutlined, IssueTypeIcon } from "@/icons"
import { TRIAGE_DRAWER_ID } from "@/organisms/Drawers/const"
import { useDrawer } from "@/organisms/Drawers/hooks/useDrawer"

import styles from "./VulnerableFunctionsTabAdr.module.scss"

import type { CVEIncident } from "@/domain/adr"

type Vulnerable = CVEIncident["what"]["vulnerabilities"][number]

const Component = (props: { record: Vulnerable }) => {
  const { record } = props
  const { t: tAll } = useTranslation()
  const { onRowClick } = useDrawer(TRIAGE_DRAWER_ID)
  const id = record.relatedIssue?.id
  const { response } = useIssue(id, undefined, { enabled: !!id })
  const description = response?.data?.cwe?.description || ""

  return (
    <Flex align="center">
      <Flex flex={1} className={styles.cveDetails}>
        <IssueTypeIcon
          severity={response?.data?.severity}
          type="Vulnerable_Package"
          className={styles.cveDetailsIcon}
        />
        <Flex align="center">
          <span className={styles.cveDetailsTitle}>{record.cve}</span>
        </Flex>
        <span className={styles.fullCell}>
          {description || <Skeleton.Input active size="small" />}
        </span>
        <Flex
          gap={6}
          align="center"
          className={cn(styles.fullCell, styles.cveDetailsFunction)}
        >
          <FunctionOutlined className="sm-text-ks" />
          <span>{record.vulnerableFunctions}</span>
        </Flex>
      </Flex>
      <Flex>
        {!!record.relatedIssue?.id && (
          <Button
            type="link"
            size="small"
            className={cn("sm-text-ks", styles.details)}
            onClick={() => onRowClick({ key: record.relatedIssue.id })}
          >
            {tAll("general.details")}
          </Button>
        )}
      </Flex>
    </Flex>
  )
}

export const CveCard = (_: unknown, record: Vulnerable) => (
  <Component record={record} />
)
